// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import EditableField from '../../../../shared/components/editable-field';
import InputWithError from './input-with-error';
import LabeledFormInput from '../../../../shared/components/labeled-form-input';
import {getFieldClassName} from '../../../shared/services/claim-shared-helper';
import {stripSpaces} from '../../../../shared/services/strip-spaces';

function handleChange(event) {

    this.onChange(event.target.value, event);

}

function handleBlur(event) {

    const processedValue = stripSpaces(event.target.value);

    this.onBlur(processedValue);
    this.onChange(processedValue);

}

const LabeledInputWithBlur = ({className, highlightClass, isValid, label, isEditable, formatter, type = 'text', value, vsrMessage, ...props}) => {

    const modifiedClassName = getFieldClassName(className, isValid, highlightClass);

    return (
        <LabeledFormInput
            className={modifiedClassName}
            label={label}
        >
            <EditableField
                isEditable={isEditable}
                value={formatter ? formatter(value) : value}
            >
                <InputWithError
                    {...props}
                    isValid={isValid}
                    onBlur={props::handleBlur}
                    onChange={props::handleChange}
                    type={type}
                    value={value}
                    vsrMessage={vsrMessage}
                />
            </EditableField>
        </LabeledFormInput>
    );

};

LabeledInputWithBlur.displayName = 'LabeledInputWithBlur';
LabeledInputWithBlur.propTypes = {
    className: PropTypes.string.isRequired,
    errorMessage: PropTypes.string.isRequired,
    formatter: PropTypes.func,
    highlightClass: PropTypes.string,
    isEditable: PropTypes.bool.isRequired,
    isValid: PropTypes.bool.isRequired,
    label: PropTypes.string.isRequired,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    type: PropTypes.string,
    value: PropTypes.string.isRequired,
    vsrMessage: PropTypes.string
};

export default LabeledInputWithBlur;



// WEBPACK FOOTER //
// ./src/claim/shared/components/claim-fields/labeled-input-with-blur.js